import React from 'react';
import { components } from 'react-select';

export const Option = props => {
  return (
    <div className="checkbox-react-select">
      <components.Option {...props}>
        <input type="checkbox" checked={props.isSelected} onChange={() => null} />
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};
